import { LoadingPage } from '@yes.technology/react-toolkit'
import { ErrorMessage } from 'infrastructure/shared/types'
import { postProcess } from 'processmodel/shared/api'
import { PostProcessResponse } from 'processmodel/shared/types/postProcess.type'
import React, { useEffect, useRef } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import useGateway from 'shared/hooks/useGateway'

function ProcessModelContainer() {
  const isFetching = useRef(false)

  const { processModelUuid } = useParams()

  const navigate = useNavigate()

  const [searchParams] = useSearchParams()

  const { navigateToTaskScreen } = useGateway()

  useEffect(() => {
    if (!processModelUuid) return

    if (isFetching.current) return

    isFetching.current = true

    let clientTracking = ''
    const params: { [key: string]: string } = {}
    searchParams.forEach((value, key) => {
      key === 'clientTracking'
        ? (clientTracking = value)
        : (params[key] = value)
    })

    const hideInteractionContainer =
      searchParams.has('hideInteractionContainer') ?? false

    postProcess({
      processmodel_uuid: String(processModelUuid),
      clientTracking,
      dataContainerParams: params
    })
      .then((response: PostProcessResponse) => {
        if (response.success) {
          const tokenUuid = response.data.process.token_uuids[0]

          window.parent.postMessage(
            {
              tokenUuid
            },
            '*'
          )

          navigate(
            `/token/${tokenUuid}${hideInteractionContainer ? `?hideInteractionContainer=true` : ''}`,
            { replace: true }
          )
        }
      })
      .catch((error: ErrorMessage) => {
        console.log(error)
        navigateToTaskScreen()
      })
  }, [processModelUuid, navigate, searchParams, navigateToTaskScreen])

  if (!processModelUuid) return null

  return <LoadingPage />
}

export default ProcessModelContainer
